export default {
  namespaced: true,
  state: {
    instructionsData: {},
    types: {},
    loadTypes: false,
    itemsPerPage: 50,
    modal: {
      url: null,
      isShow: false,
      svg: null
    },
    modalCond: {
      isShow: false,
      data: null
    }
  },
  getters: {},
  mutations: {
    showModalCond (state, payload) {
      state.modalCond.isShow = true
      state.modalCond.data = payload
    },
    setData (state, { subtable, data, totalCount }) {
      state.instructionsData[subtable] = { data: data, totalCount: Number(totalCount) }
    },
    setTypes (state, { data, table }) {
      state.types[table] = data
    },
    showModal (state, { url, svg }) {
      state.modal.isShow = true
      if (url) {
        state.modal.url = url
        state.modal.svg = null
      }
      if (svg) {
        state.modal.svg = svg
        state.modal.url = null
      }
    },
    setPageSize (state, val) {
      state.itemsPerPage = val
    }
  },
  actions: {
    getTypes ({ state, rootState, commit }, { categoryId } = {}) {
      state.loadTypes = true
      return fetch(`${rootState.api.host}${rootState.api.endpoint.instructionTypes}${categoryId ? '?category_id=' + categoryId : ''}`, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      })
        .then(response => response.json())
        .then(data => {
          commit('setTypes', { data: data, table: categoryId || 'all' })
          state.loadTypes = false
        })
    },
    async getInstructions ({ rootState, rootGetters, commit, state }, { routeParams, searchValue, page, filter }) {
      const subtable = routeParams.subtable
      let categoryIds = [subtable.split('-')[0]]
      if (window.localStorage.getItem('showAllTabs') === 'true') {
        const categoriesData = rootGetters['partCategories/subCategories'](routeParams)
        categoryIds = categoriesData?.table?.subCategories.map(tab => tab.id)
        state.itemsPerPage = 250
      }
      const instructions = await fetch(`${rootState.api.host}${rootState.api.endpoint.instruction}?category_ids=${categoryIds.join(',')}&page_size=${state.itemsPerPage}${searchValue ? '&search=' + searchValue : ''}${page ? '&page=' + page : ''}${filter ? '&filter=' + filter : ''}`, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      })
      if (instructions.ok) {
        const data = await instructions.json()
        const totalCount = instructions.headers.get('x-total-count')
        if (data) commit('setData', { subtable, data, totalCount })
      }
    },
    async getInstruction ({ rootState }, id) {
      const getInstruction = await fetch(`${rootState.api.host}${rootState.api.endpoint.instruction}/${id}`, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      })
      if (getInstruction.ok) {
        const response = await getInstruction.json()
        if (response) {
          response.conditions = []
          response.cond.forEach((condition, index) => {
            response.conditions.push([])
            for (const key in condition) {
              const value = condition[key] instanceof Array ? condition[key].join() : condition[key]
              response.conditions[index].push({ key: key, value: value })
            }
          })
          response.files = []
          return response
        } else return false
      } else return false
    },
    async deleteInstruction ({ rootState, commit }, id) {
      const deleted = await fetch(`${rootState.api.host}${rootState.api.endpoint.instruction}/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      })
      if (deleted.ok) {
        commit('notifications/addNotification', {
          notification: {
            type: 'success',
            message: 'The step deleted.'
          }
        }, { root: true })
        return true
      } else {
        commit('notifications/addNotification', {
          notification: {
            type: 'danger',
            message: 'Step is not deleted. Try again'
          }
        }, { root: true })
        return false
      }
    },
    async updateInstruction ({ rootState, commit }, { value, id }) {
      const update = await fetch(`${rootState.api.host}${rootState.api.endpoint.instruction}/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + rootState.user.accesToken
        },
        body: JSON.stringify(value)
      })
      if (update.ok) {
        commit('notifications/addNotification', {
          notification: {
            type: 'success',
            message: 'Instruction updated'
          }
        }, { root: true })
        return true
      } else {
        const response = await update.json()
        for (const key in response.errors) {
          commit('notifications/addNotification', {
            notification: {
              type: 'danger',
              message: response.errors[key].join(' ')
            }
          }, { root: true })
        }
        return false
      }
    },
    async createInstruction ({ rootState, commit }, { value }) {
      const create = await fetch(`${rootState.api.host}${rootState.api.endpoint.instruction}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + rootState.user.accesToken
        },
        body: JSON.stringify(value)
      })
      if (create.ok) {
        commit('notifications/addNotification', {
          notification: {
            type: 'success',
            message: 'Instruction created'
          }
        }, { root: true })
        return true
      } else {
        const response = await create.json()
        for (const key in response.errors) {
          commit('notifications/addNotification', {
            notification: {
              type: 'danger',
              message: response.errors[key].join(' ')
            }
          }, { root: true })
        }
        return false
      }
    },
    async createImages ({ rootState, commit }, value) {
      const sendImg = await fetch(`${rootState.api.host}${rootState.api.endpoint.imagesInstruction}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + rootState.user.accesToken
        },
        body: JSON.stringify(
          {
            image_base64: value.image_base64,
            mime: value.mime
          }
        )
      })
      if (sendImg.ok) {
        const response = await sendImg.json()
        return response
      } else {
        commit('notifications/addNotification', {
          notification: {
            type: 'danger',
            message: "Images didn't load, please try again"
          }
        }, { root: true })
        return false
      }
    },
    async checkLink ({ rootState }, { id, link }) {
      const data = await fetch(`${rootState.api.host}/instructions/${id}/check-design?trace=1`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + rootState.user.accesToken
        },
        body: JSON.stringify(
          {
            link
          }
        )
      })
      return data
    }
  }
}
